import isEqual from "lodash.isequal"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { createActions, createReducer } from "reduxsauce"

import { defaultFiltersByFolders } from "../../Utils/utils"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getCreditsStatisticsRequest: ["payload"], // payload: { params }
  getCreditsStatisticsSuccess: ["payload"], // payload: { data }
  getCreditsStatisticsFailure: ["payload"], // payload: { data }

  getCreditsFilterOptionsRequest: ["payload"], // payload: { params }
  getCreditsFilterOptionsSuccess: ["payload"], // payload: { data }
  getCreditsFilterOptionsFailure: ["payload"], // payload: { data }

  getCreditsRequest: ["payload"], // payload: { params }
  getCreditsSuccess: ["payload"], // payload: { data }

  updateCreditRequest: ["payload"], // payload: { params }
  updateCreditSuccess: ["payload"], // payload: { newCredit }

  pinCreditRequest: ["payload"], // payload: { params }
  pinCreditSuccess: ["payload"], // payload: { newCredit }

  deleteCreditRequest: ["payload"], // payload: { params }
  deleteCreditSuccess: ["payload"], // payload: { newCredit }

  getCreditsOtherPageRequest: ["payload"], // payload: { params }
  getCreditsOtherPageSuccess: ["payload"], // payload: { data }
  creditsFailure: ["payload"], // payload: { errors }

  clearCreditsFilters: ["payload"],
  creditsSetProp: ["key", "value"],

  getCreditsExportRequest: ["payload"], // payload: { data }
  getCreditsExportSuccess: ["payload"], // payload: { url }
  getCreditsExportFailure: ["payload"], // payload: { errors }

  getCreditDetailsRequest: ["payload"], // payload: { creditID }
  getCreditDetailsSuccess: ["payload"], // payload: { creditDetails }
  getCreditDetailsFailure: ["payload"], // payload: { errors }

  attachProofCreditRequest: ["payload"], // payload: { data }
  attachProofCreditSuccess: ["payload"],
  attachProofCreditFailure: ["payload"], // payload: { errors }

  resubmitCreditRequestRequest: ["payload"], // payload: { data }
  resubmitCreditRequestSuccess: ["payload"], // payload: { data }
  resubmitCreditRequestFailure: ["payload"], // payload: { errors }
  resetSaveResult: null,
  logout: null,
  creditDetailsReset: null
})

export const CreditsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columns = [
  //{field_id: 'request_status', label: 'Request status', active: true},
  { field_id: "transaction_id", label: "Transaction ID", active: true },
  { field_id: "alert_status", label: "Alert status", active: true },
  { field_id: "request_reason", label: "Request reason", active: true },
  { field_id: "request_date_timestamp", label: "Request date", active: true },
  { field_id: "alert_service", label: "Alert source", active: true },
  { field_id: "request_amount", label: "Alert cost", active: true },
  { field_id: "alert_id", label: "Alert ID", active: true },
  { field_id: "merchant_descriptor", label: "Billing descriptor", active: true },
  { field_id: "card_last4", label: "Card", active: true },
  { field_id: "amount", label: "Order value", active: true },
  { field_id: "transaction_timestamp", label: "Transaction date", active: true },
  { field_id: "request_type", label: "Request type", active: true },

  { field_id: "alert_reason", label: "Alert reason", active: false },
  { field_id: "alert_timestamp", label: "Alert date", active: false },
  { field_id: "country", label: "Country", active: false },
  { field_id: "bank_name", label: "Bank", active: false },
  { field_id: "payment_processor", label: "Processor", active: false },
  { field_id: "arn", label: "ARN", active: false },
  { field_id: "auth_code", label: "Auth.Code", active: false },
  { field_id: "alert_type", label: "Type", active: false },
  { field_id: "rejection_reason", label: "Rejection reason", active: false },
  { field_id: "original_alert_id", label: "Original alert", active: false }
]

const columnsAdmin = [
  //{field_id: 'request_type', label: 'Request type', active: true},
  { field_id: "request_status", label: "Request status", active: true },
  { field_id: "provider_status", label: "Provider status", active: true },
  { field_id: "request_date_timestamp", label: "Request date", active: true },
  { field_id: "update_date_timestamp", label: "Update date", active: true },
  { field_id: "request_amount", label: "Alert cost", active: true },
  { field_id: "business_account", label: "Business account", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "alert_status", label: "Alert status", active: true },
  { field_id: "alert_timestamp", label: "Alert date", active: true },
  { field_id: "alert_service", label: "Alert source", active: true },
  { field_id: "request_reason", label: "Request reason", active: true },
  { field_id: "alert_id", label: "Alert ID", active: true },
  { field_id: "transaction_id", label: "Transaction ID", active: true },
  { field_id: "rejection_reason", label: "Rejection reason", active: true },
  { field_id: "provider_reason", label: "Provider reason", active: true },
  { field_id: "attachments", label: "Attachments", active: true },

  { field_id: "admin_comment", label: "Comment", active: true },
  { field_id: "admin_screenshots", label: "Screenshots", active: true },
  { field_id: "original_alert_id", label: "Original alert", active: true }
]

export const INITIAL_STATE = {
  fetchingStatistics: false,
  statistics: {
    //used for header with navIcon (common statistic)
    all: 0,
    ethoca: 0,
    cdrn: 0,
    rdr: 0,
    verifi: 0,
    manual: 0,
    system: 0,
    requires_proof: 0
  },
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: [],
    requires_proof_list: [],
    statistic: {
      all: 0,
      ethoca: 0,
      cdrn: 0,
      rdr: 0,
      verifi: 0,
      manual: 0,
      system: 0,
      requires_proof: 0
    }
  },
  defaultColumns: [{ field_id: "request_status", label: "Request status" }, ...columns],
  columns: [...columns],

  defaultColumnsAdmin: [{ field_id: "request_type", label: "Request type" }, ...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    alert_timestamp: null,
    transaction_timestamp: null,
    request_date_timestamp: null,
    update_date_timestamp: null,

    alert_status: "all",
    alert_type: "all",
    alert_reason: "all",
    alert_service: "all",
    request_status: "all",
    request_type: "all",
    request_reason: "all",
    rejection_reason: "all",
    provider_reason: "all",
    provider_status: "all",

    user_email: [],
    customer_email: [],
    business_account: [],
    business_url: [],

    request_amount: { min: null, max: null, type: null },
    amount: { min: null, max: null, type: null },
    attachments: { min: null, max: null, type: null },

    bank_name: "all",
    merchant_descriptor: "all",
    country: "all",
    payment_processor: "all",
    alert_id: [],
    transaction_id: [],
    arn: [],
    auth_code: [],
    card_last4: [],
    exclude_fields: [],
    is_archived: null,
    admin_comment: [],
    admin_screenshots: "all"
  },

  fetchingFilterOptions: false,
  filterOptions: {
    alert_status: [],
    alert_type: [],
    alert_reason: [],
    country: [],
    bank_name: [],
    payment_processor: [],
    customer_unsubscribed: [],
    admin_comment: []
  },

  visibleFilters: { request_status: true, transaction_id: true, alert_status: true },
  visibleFiltersAdmin: { request_status: true, provider_status: true, business_account: true },

  exportFetching: false,
  exportResult: null,

  saveFetching: false,
  saveResult: null,

  creditDetailsFetching: false,
  creditDetails: null,

  creditsViewMode: "table"
}

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state, folder) => {
  const defaultFilters = defaultFiltersByFolders.credits?.[folder] || INITIAL_STATE.filters

  const filtersToCompare = {
    ...INITIAL_STATE.filters,
    provider_status: defaultFilters.provider_status,
    is_archived: defaultFilters.is_archived
  }

  return isEqual(filtersToCompare, state.credits.filters)
}

/* ------------- Functions for reducer cases ------------- */
const getCreditsStatisticsRequest = (state) => ({ ...state, fetchingStatistics: true })
const getCreditsStatisticsSuccess = (state, { payload: statistics }) => ({
  ...state,
  fetchingStatistics: false,
  statistics: { ...statistics, verifi: (statistics?.cdrn || 0) + (statistics?.rdr || 0) }
})
const getCreditsStatisticsFailure = (state) => ({ ...state, fetchingStatistics: false })

const getCreditsFilterOptionsRequest = (state) => ({ ...state, fetchingFilterOptions: true })
const getCreditsFilterOptionsSuccess = (state, { payload: filterOptions }) => ({
  ...state,
  fetchingFilterOptions: false,
  filterOptions
})
const getCreditsFilterOptionsFailure = (state) => ({ ...state, fetchingFilterOptions: false })

const getCreditsRequest = (state) => ({ ...state, fetching: true })
const getCreditsSuccess = (state, { payload: result }) => ({ ...state, fetching: false, result })
const getCreditsOtherPageRequest = (state) => ({ ...state, fetching: true })
const getCreditsOtherPageSuccess = (state, { payload: result }) => ({
  ...state,
  fetching: false,
  result
})
const creditsFailure = (state) => ({ ...state, fetching: false })

const updateCreditRequest = (state) => ({ ...state, fetching: true })
const updateCreditSuccess = (state, { payload: result }) => ({
  ...state,
  fetching: false,
  saveResult: result?.message
    ? { type: "credit_update", message: result?.message }
    : "credit_update"
})

const pinCreditRequest = (state) => ({ ...state, fetching: true })
const pinCreditSuccess = (state) => ({
  ...state,
  fetching: false,
  saveResult: "pin"
})

const deleteCreditRequest = (state) => ({ ...state, fetching: true })
const deleteCreditSuccess = (state) => ({
  ...state,
  fetching: false,
  saveResult: "delete"
})

export const creditsSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return { ...state, ...obj }
}

export const clearCreditsFilters = (state, { payload: data }) => {
  return { ...state, filters: { ...INITIAL_STATE.filters, ...data } }
}

const getCreditsExportRequest = (state) => ({ ...state, exportFetching: true })
const getCreditsExportSuccess = (state, { payload: exportResult }) => ({
  ...state,
  exportFetching: false,
  exportResult
})
const getCreditsExportFailure = (state) => ({ ...state, exportFetching: false })

const getCreditDetailsRequest = (state) => ({ ...state, creditDetailsFetching: true })
const getCreditDetailsSuccess = (state, { payload: creditDetails }) => ({
  ...state,
  creditDetailsFetching: false,
  creditDetails
})
const resetCreditDetails = (state) => ({ ...state, creditDetails: null })
const getCreditDetailsFailure = (state) => ({ ...state, creditDetailsFetching: false })

const attachProofCreditRequest = (state) => ({ ...state, saveFetching: true })
const attachProofCreditSuccess = (state) => ({
  ...state,
  saveFetching: false,
  saveResult: "attach_proof"
})
const attachProofCreditFailure = (state) => ({ ...state, saveFetching: false })

const resubmitCreditRequestRequest = (state) => ({ ...state, saveFetching: true, fetching: true })
const resubmitCreditRequestSuccess = (state) => ({
  ...state,
  saveFetching: false,
  saveResult: "credit_request_resubmit",
  fetching: false
})
const resubmitCreditRequestFailure = (state) => ({ ...state, saveFetching: false, fetching: false })

const resetSaveResult = (state) => ({ ...state, saveResult: null })

const logout = () => ({ ...INITIAL_STATE })

/* ------------- Hookup Reducers To Types ------------- */
const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CREDITS_STATISTICS_REQUEST]: getCreditsStatisticsRequest,
  [Types.GET_CREDITS_STATISTICS_SUCCESS]: getCreditsStatisticsSuccess,
  [Types.GET_CREDITS_STATISTICS_FAILURE]: getCreditsStatisticsFailure,

  [Types.GET_CREDITS_FILTER_OPTIONS_REQUEST]: getCreditsFilterOptionsRequest,
  [Types.GET_CREDITS_FILTER_OPTIONS_SUCCESS]: getCreditsFilterOptionsSuccess,
  [Types.GET_CREDITS_FILTER_OPTIONS_FAILURE]: getCreditsFilterOptionsFailure,

  [Types.GET_CREDITS_REQUEST]: getCreditsRequest,
  [Types.GET_CREDITS_SUCCESS]: getCreditsSuccess,

  [Types.UPDATE_CREDIT_REQUEST]: updateCreditRequest,
  [Types.UPDATE_CREDIT_SUCCESS]: updateCreditSuccess,

  [Types.PIN_CREDIT_REQUEST]: pinCreditRequest,
  [Types.PIN_CREDIT_SUCCESS]: pinCreditSuccess,

  [Types.DELETE_CREDIT_REQUEST]: deleteCreditRequest,
  [Types.DELETE_CREDIT_SUCCESS]: deleteCreditSuccess,

  [Types.GET_CREDITS_OTHER_PAGE_REQUEST]: getCreditsOtherPageRequest,
  [Types.GET_CREDITS_OTHER_PAGE_SUCCESS]: getCreditsOtherPageSuccess,

  [Types.CREDITS_FAILURE]: creditsFailure,

  [Types.CLEAR_CREDITS_FILTERS]: clearCreditsFilters,

  [Types.CREDITS_SET_PROP]: creditsSetProp,

  [Types.GET_CREDITS_EXPORT_REQUEST]: getCreditsExportRequest,
  [Types.GET_CREDITS_EXPORT_SUCCESS]: getCreditsExportSuccess,
  [Types.GET_CREDITS_EXPORT_FAILURE]: getCreditsExportFailure,

  [Types.GET_CREDIT_DETAILS_REQUEST]: getCreditDetailsRequest,
  [Types.GET_CREDIT_DETAILS_SUCCESS]: getCreditDetailsSuccess,
  [Types.GET_CREDIT_DETAILS_FAILURE]: getCreditDetailsFailure,

  [Types.ATTACH_PROOF_CREDIT_REQUEST]: attachProofCreditRequest,
  [Types.ATTACH_PROOF_CREDIT_SUCCESS]: attachProofCreditSuccess,
  [Types.ATTACH_PROOF_CREDIT_FAILURE]: attachProofCreditFailure,

  [Types.RESUBMIT_CREDIT_REQUEST_REQUEST]: resubmitCreditRequestRequest,
  [Types.RESUBMIT_CREDIT_REQUEST_SUCCESS]: resubmitCreditRequestSuccess,
  [Types.RESUBMIT_CREDIT_REQUEST_FAILURE]: resubmitCreditRequestFailure,

  [Types.RESET_SAVE_RESULT]: resetSaveResult,
  [Types.LOGOUT]: logout,
  [Types.CREDIT_DETAILS_RESET]: resetCreditDetails
})

const PERSISTED_REDUCER_VERSION = 4

export const persistedReducer = persistReducer(
  {
    key: "credits",
    version: PERSISTED_REDUCER_VERSION,
    storage,
    blacklist: [
      "fetchingStatistics",
      "fetching",
      "saveFetching",
      "saveResult",
      "fetchingFilterOptions",
      "exportFetching",
      "creditDetailsFetching"
    ],
    migrate: async (state) => {
      if (state?._persist?.version < PERSISTED_REDUCER_VERSION) {
        return {
          ...state,
          ...INITIAL_STATE
        }
      }
      return state
    }
  },
  reducer
)
